import {Injectable}             from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    //NavigationExtras
}       from '@angular/router';
import {LoginService}            from '../login/login.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private loginService: LoginService,
                private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        if (this.loginService.isLoggedIn() && !this.loginService.getDecodeToken().cambiarPassword) {
            return true;
        }

        // Store the attempted URL for redirecting
        this.loginService.redirectUrl = state.url;

        if (!this.loginService.isLoggedIn())
        // Navigate to the login page with extras
            this.router.navigate(['/login']);
        else
            this.router.navigate(['/cambiarPassword']);

        return false;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/auth/auth-guard.service.ts